import {BasisRessurs} from "../../infrastruktur/BasisRessurs";
import {l} from "../../../types/typescriptdefinisjoner_lederplan";
import {Konfigurasjon} from "../../infrastruktur/Konfigurasjon";
import {Strenger} from "../Strenger";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import "angular-resource/index";
import {regNavn} from "../tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import debug from "debug";
import _ from "lodash";


export class AsynkOppgaveRessurs extends BasisRessurs<l.AsynkOppgaveModell> {
    static regNavn = 'asynkOppgaveRessurs';
    static forInjisering() {
        return [
            '$resource',
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            AsynkOppgaveRessurs
        ];
    }

    constructor($resource: ng.resource.IResourceService,
                ressursFeilhåndtering: RessursFeilhåndtering,
                gettextCatalog: gettextCatalog) {
        super('asynkOppgave',
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {
                hentAlle: {method: 'GET', url: '/api/admin/asynkOppgaver', isArray: true},
                restart: {method: 'POST', url: '/api/admin/asynkOppgaver/:id/restart'},
                parker: {method: 'DELETE', url: '/api/admin/asynkOppgaver/:id'}
            }
        );
    }

    hentAlle(status: l.AsynkOppgaveStatus): l.AsynkOppgaveModell[] {
        debug('hentAlle');
        return this.ressurs['hentAlle'](
            status != undefined ? {statusFilter: status} : {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke hente asynk oppgaver'))
        )
    }

    kjorIgjen(oppgave): l.AngularRessurs<l.AsynkOppgaveModell> {
        debug('restart');
        return this.ressurs['restart'](
            {id: oppgave.id},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke restarte oppgave'))
        );
    }

    parker(oppgave: l.AsynkOppgaveModell): l.AngularRessurs<l.AsynkOppgaveModell> {
        debug('parker');
        return this.ressurs['parker'](
            {id: oppgave.id},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke parkere oppgave'))
        );
    }
}
